import { ProgressBar } from "@bokio/companies/src/scenes/Overview/components/OnboardingChecklist/ProgressBar/ProgressBar";
import { Paragraph } from "@bokio/designsystem/components/TypographicElements/TypographicElements";

import type { FC } from "react";

import * as styles from "./planProgressBar.scss";

interface PlanProgressBarProps {
	daysRemanining?: number;
	percent?: number;
	max?: number;
	visibleNumbericalProgress?: boolean;
	headingText?: string;
	isLosingPlanAccess?: boolean;
}

export const PlanProgressBar: FC<PlanProgressBarProps> = ({
	daysRemanining = 0,
	percent = 0,
	headingText = "",
	isLosingPlanAccess = false,
}) => {
	return (
		<div data-testid="planProgressBar_test">
			<Paragraph data-testid="planProgressBar_headingText_test">
				<span className={styles.headingDaysRemaining}>{daysRemanining}</span>
				{headingText}
			</Paragraph>
			<ProgressBar
				percent={percent}
				showNumericalProgress={false}
				color={isLosingPlanAccess ? "warn" : "dark"}
				overRidingPixelHeight={12}
			></ProgressBar>
		</div>
	);
};
